import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';

import { AtlasService } from '../service/atlas.service';

/**
 * Restricts a route to admins holding the Atlas `owner` role.
 *
 * This is a convenience gate, not the control: every Atlas endpoint re-checks the
 * caller server-side, so a non-Owner who reaches the URL directly would still get
 * nothing back. Hiding the route just avoids showing a page that can only fail.
 *
 * Anyone who isn't an Owner — including admins with no Atlas role at all, who get a
 * 403 from /atlas/roles — is sent to the standard dashboard rather than an error page.
 */
export const atlasOwnerGuard: CanActivateFn = () => {
  const atlas = inject(AtlasService);
  const router = inject(Router);

  return atlas.isOwner().pipe(map((isOwner) => isOwner || router.createUrlTree(['/dashboard/overview'])));
};
